import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BKJLoadingSpinner, Flex } from '../index.js';
import { BKJInteractiveMapProvider, useBKJInteractiveMapContext, } from '../BKJInteractiveMap/BKJInteractiveMap.context.js';
import { isClusterType as isClusterPropsType, isPointType as isPinPropsType, } from '../BKJInteractiveMap/BKJInteractiveMap.types.js';
import GoogleMapReact from 'google-map-react';
import styled from 'styled-components';
const Marker = ({ children }) => children;
const Overlay = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  background: #00000010;
  background-color: #00000010;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;
const MapComponent = () => {
    const { clusters, apiKey, pinComponent, clusterComponent, defaultCenter, defaultZoom, maxZoom, minZoom, onMapChange, gMapInstance, onGoogleApiLoaded, supercluster, onDrag, onDragEnd, zoom, isLoading, } = useBKJInteractiveMapContext();
    return (_jsxs(Flex, { width: "100%", maxWidth: "100%", minWidth: "100%", height: "100%", maxHeight: "100%", minHeight: "100%", style: { overflow: 'hidden', position: 'relative' }, children: [isLoading && (_jsx(Overlay, { children: _jsx(BKJLoadingSpinner, { variant: "Default" }) })), _jsx(GoogleMapReact, { options: { gestureHandling: 'greedy', maxZoom, minZoom }, bootstrapURLKeys: { key: apiKey }, defaultCenter: defaultCenter, defaultZoom: defaultZoom, yesIWantToUseGoogleMapApiInternals: true, onGoogleApiLoaded: onGoogleApiLoaded, onChange: onMapChange, onDrag: onDrag, onDragEnd: onDragEnd, zoom: zoom, children: clusters.map((data) => {
                    if (isClusterPropsType(data)) {
                        const [longitude, latitude] = data.geometry.coordinates;
                        const key = `CLUSTER-${data.id}-${longitude}-${latitude}`;
                        const ClusterComponent = clusterComponent;
                        const { onClick, ...rest } = data;
                        return (_jsx(Marker, { lat: latitude, lng: longitude, children: _jsx(ClusterComponent, { ...rest, childNodes: supercluster.getChildren(data.id), onClick: (e) => {
                                    const expansionZoom = Math.min(supercluster.getClusterExpansionZoom(Number.parseInt(data.id, 10)), 20);
                                    gMapInstance.setZoom(expansionZoom);
                                    gMapInstance.panTo({ lat: latitude, lng: longitude });
                                    onClick && onClick(e);
                                } }) }, key));
                    }
                    if (isPinPropsType(data)) {
                        const [longitude, latitude] = data.geometry.coordinates;
                        const key = `PIN-${longitude}-${latitude}`;
                        const PinComponent = pinComponent;
                        return (_jsx(Marker, { lat: latitude, lng: longitude, children: _jsx(PinComponent, { ...data }) }, key));
                    }
                    throw new Error('Unknown Cluster Type');
                }) })] }));
};
export const BKJInteractiveMap = (props) => {
    const { children, ...rest } = props;
    return (_jsx(BKJInteractiveMapProvider, { ...rest, children: _jsx(MapComponent, {}) }));
};
//# sourceMappingURL=BKJInteractiveMap.js.map